export const selectCompetenceState = state => state.competence;
